import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportsPage from '../components/reports/ReportsPage';
import * as catalogActions from '../redux/actions/catalogActions';

function mapStateToProps(state) {
  return {
    catalog: state.catalogReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...catalogActions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage);
